/* ==========================================================================
   treasure_castle_home_motion.js
   Treasure Castle トップページ プロトタイプ モーション

   ★ デザイン・モーション確認用のローカルプロトタイプです。
   ★ Shopify へ投入しません。
   ★ 外部ライブラリを使用しません。
   ★ 使用する API は IntersectionObserver / matchMedia / getTotalLength のみ。
   ★ fetch / XHR / eval を使用しません。
   仕様: docs/67
   ========================================================================== */

/* ==========================================================================
   A. カルーセル位置モデル（★純粋関数のみ・DOM に触れない）

   集中再監査で、carIndex / 実 scrollLeft / smooth scroll の目的位置 /
   手動スワイプ後の位置 が一致しない不具合が確認された。
   位置判定の正本を【実 scrollLeft】へ移すため、
   位置計算をここへ切り出し、Node から反例テストできるようにする。

   使い方（Node）
       var M = require('./treasure_castle_home_motion.js');
       M.buildSnaps([0,156,312,468,624,780], 592, 1);
   ========================================================================== */
(function (root, factory) {
  var model = factory();
  if (typeof module === 'object' && module && module.exports) {
    module.exports = model;                 // Node からの反例テスト用
  }
  if (root) { root.TCCarouselModel = model; }
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var EPS_SNAP = 1;      // スナップ位置の重複統合に使う許容誤差（px）
  var EPS_EDGE = 2;      // 端（先頭 / maxScroll）判定の許容誤差（px）

  function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }

  /* 到達可能なスナップ位置を、カードの実描画位置から作る。

     ★カード幅や固定 gap の推定値を使わない。
     ★0〜maxScroll へ clamp し、1px 以内の重複を統合する。
     ★最終位置は必ず maxScroll を含める
       （そうしないと最後のカードが完全に表示されないまま
         Next が disabled になる。監査で確認された不具合）。
     ★カード数と到達可能なスナップ位置数は一致しなくてよい。 */
  function buildSnaps(offsets, maxScroll, eps) {
    eps = (eps === undefined) ? EPS_SNAP : eps;
    if (!offsets || !offsets.length) { return [0]; }
    if (maxScroll <= eps) { return [0]; }          // 全件が見えている
    var out = [];
    for (var i = 0; i < offsets.length; i++) {
      var v = clamp(offsets[i], 0, maxScroll);
      if (!out.length || v - out[out.length - 1] > eps) { out.push(v); }
    }
    if (!out.length || out[0] > eps) { out.unshift(0); }
    var last = out[out.length - 1];
    if (maxScroll - last > eps) { out.push(maxScroll); }
    else { out[out.length - 1] = maxScroll; }      // ★必ず maxScroll で終わる
    return out;
  }

  /* 与えられた位置に最も近い要素の番号 */
  function nearestIndex(list, value) {
    var best = 0, bestD = Infinity;
    for (var i = 0; i < list.length; i++) {
      var d = Math.abs(list[i] - value);
      if (d < bestD) { bestD = d; best = i; }
    }
    return best;
  }

  /* 矢印の disabled 判定。
     ★内部の番号ではなく【実 scrollLeft】だけで決める。
     ★requestedIndex が最終位置を指していても、
       実 scrollLeft が maxScroll に達していなければ Next を disabled にしない。 */
  function disabledState(scrollLeft, maxScroll, eps) {
    eps = (eps === undefined) ? EPS_EDGE : eps;
    var all = maxScroll <= eps;
    return {
      allVisible: all,
      prev: all || scrollLeft <= eps,
      next: all || scrollLeft >= maxScroll - eps
    };
  }

  /* カウンター。実際の表示位置と矛盾させない。
     ★maxScroll では最後のカードが見えているので total を返す。 */
  function counterValue(scrollLeft, maxScroll, cardOffsets, total, eps) {
    eps = (eps === undefined) ? EPS_EDGE : eps;
    if (maxScroll <= eps) { return { allVisible: true, value: total }; }
    if (scrollLeft >= maxScroll - eps) { return { allVisible: false, value: total }; }
    return {
      allVisible: false,
      value: nearestIndex(cardOffsets, scrollLeft) + 1
    };
  }

  /* 1段だけ進める / 戻す。範囲外へ出さない。 */
  function stepIndex(current, delta, snapCount) {
    return clamp(current + delta, 0, Math.max(0, snapCount - 1));
  }

  return {
    EPS_SNAP: EPS_SNAP,
    EPS_EDGE: EPS_EDGE,
    clamp: clamp,
    buildSnaps: buildSnaps,
    nearestIndex: nearestIndex,
    disabledState: disabledState,
    counterValue: counterValue,
    stepIndex: stepIndex
  };
}));

/* ==========================================================================
   B. DOM 側（★ブラウザでのみ実行する。Node から require しても動かない）
   ========================================================================== */
if (typeof document !== 'undefined') { (function () {
  'use strict';

  var M = window.TCCarouselModel;
  var root = document.documentElement;
  root.classList.remove('no-js');           // 既定を「見えない」にしない

  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var smallMQ = window.matchMedia('(max-width: 767px)');
  var observer = null;

  /* ------------------------------------------------------------------
     1. SVG の path 長を1回だけ計測（CSS の dashoffset に使う）
     ------------------------------------------------------------------ */
  function measureLines() {
    var lines = document.querySelectorAll('.tc-fig-line');
    for (var i = 0; i < lines.length; i++) {
      var len;
      try { len = lines[i].getTotalLength(); } catch (e) { len = 0; }
      if (len && isFinite(len)) {
        lines[i].style.setProperty('--len', Math.ceil(len));
      }
    }
  }

  /* ------------------------------------------------------------------
     2. スクロール表示（IntersectionObserver は1つだけ）
     ------------------------------------------------------------------ */
  function showAll() {
    var t = document.querySelectorAll('.reveal');
    for (var i = 0; i < t.length; i++) { t[i].classList.add('is-visible'); }
  }

  function startObserving() {
    if (!('IntersectionObserver' in window)) { showAll(); return; }
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('is-visible');
        observer.unobserve(entries[i].target);   // 再生し直さない
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    var t = document.querySelectorAll('.reveal');
    for (var j = 0; j < t.length; j++) { observer.observe(t[j]); }
  }

  function stopObserving() {
    if (observer) { observer.disconnect(); observer = null; }
  }

  /* ------------------------------------------------------------------
     3. ヒーローのクロスフェード
        - 6秒間隔。★自動カルーセルではなく、同一商品の別カット
        - 停止ボタンを必ず用意する
        - reduced-motion / 小画面では動かさない
     ------------------------------------------------------------------ */
  var heroTimer = null;
  var heroIndex = 0;
  var heroPlaying = true;          // 利用者の再生 / 停止の意思
  var heroToggleBound = false;     // ★click を1度だけ束縛する（多重登録の防止）

  function heroSlides() { return document.querySelectorAll('.tc-hero__slide'); }

  function heroShow(i) {
    var s = heroSlides();
    if (!s.length) return;
    for (var k = 0; k < s.length; k++) {
      s[k].setAttribute('data-active', k === i ? 'true' : 'false');
    }
  }

  function shouldAnimateHero() {
    if (reduceMQ.matches) return false;         // ★動きを減らす設定では動かさない
    if (smallMQ.matches) return false;          // スマホでは動かさない
    var c = navigator.connection;
    if (c) {
      if (c.saveData === true) return false;
      if (/2g/.test(c.effectiveType || '')) return false;
    }
    return true;
  }

  function heroStart() {
    if (heroTimer) return;
    // ★reduced motion のときはタイマーを開始しない（二重の防御）
    if (!shouldAnimateHero()) return;
    var s = heroSlides();
    if (s.length < 2) return;
    heroTimer = window.setInterval(function () {
      heroIndex = (heroIndex + 1) % s.length;
      heroShow(heroIndex);
    }, 6000);
  }

  function heroStop() {
    if (heroTimer) { window.clearInterval(heroTimer); heroTimer = null; }
  }

  function bindHeroToggle(toggle) {
    if (heroToggleBound || !toggle) return;
    heroToggleBound = true;
    toggle.addEventListener('click', function () {
      heroPlaying = !heroPlaying;
      try { window.sessionStorage.setItem('tcHeroPaused', heroPlaying ? '0' : '1'); }
      catch (e) { /* 無視 */ }
      setupHero();
    });
  }

  function setupHero() {
    var toggle = document.querySelector('[data-motion-toggle]');
    var status = document.querySelector('[data-hero-status]');
    var animate = shouldAnimateHero();

    if (status) {
      status.textContent = animate
        ? 'Status: switching enabled (desktop, standard connection, no reduced motion)'
        : 'Status: switching disabled (static display)';
    }

    // ★動かさない条件のときは、必ず停止して1枚目を見せる
    if (!animate) {
      heroStop();
      heroIndex = 0;
      heroShow(0);
      if (toggle) toggle.hidden = true;         // 不要な停止ボタンを出さない
      return;
    }

    if (!toggle) { heroStart(); return; }
    toggle.hidden = false;
    bindHeroToggle(toggle);

    try {
      if (window.sessionStorage.getItem('tcHeroPaused') === '1') heroPlaying = false;
    } catch (e) { /* sessionStorage が使えない環境は既定のまま */ }

    toggle.setAttribute('aria-pressed', String(!heroPlaying));
    toggle.textContent = heroPlaying ? 'Pause slideshow' : 'Resume slideshow';
    if (heroPlaying) { heroStart(); } else { heroStop(); }
  }

  /* ------------------------------------------------------------------
     4. ブランドカルーセル（★自動再生しない・手動のみ）
     ------------------------------------------------------------------ */
  /* 集中再監査（375px）で確認された不具合と、その原因

       ・Next を短時間に3回押すと scrollLeft 468 で Next が disabled になる
         （実際の maxScroll は 592。6枚目が完全に見えていない）
       ・連続クリックの見た目が追いつかず、後からまとめてジャンプする
       ・手動スワイプで 592 まで動かしても内部の番号が追従しない
       ・その状態で Previous を押すと 592 → 312 へ大きく戻る

     原因は2つある。

       (1) スナップ位置をカードの offsetLeft【そのまま】で持っていた。
           最後の2枚（624 / 780）は maxScroll 592 を超えて到達できないため、
           到達可能な最大の番号が 468 のカードになり、
           そこで Next が disabled になっていた。
           → maxScroll へ clamp して重複を統合し、
             ★最終スナップ位置を必ず maxScroll にする。

       (2) 位置の正本が内部の番号（carIndex）だった。
           smooth scroll の途中や手動スワイプの後は、
           番号と実 scrollLeft が食い違う。
           → ★位置判定の正本を【実 scrollLeft】へ移す。
             番号は実 scrollLeft から毎回導出する。

     状態は4つだけに分ける（必要以上に複雑にしない）。
       actualIndex          実 scrollLeft から算出した現在位置（導出値）
       requestedIndex       ボタンで要求した移動先（連続クリックの基準）
       isProgrammaticScroll ボタン操作による移動中か
       manualInteraction    スワイプ / wheel / pointer / キーによる手動操作か  */

  var carTrack = null, carPrev = null, carNext = null, carPos = null, carHint = null;
  var carItems = [];
  var carOffsets = [];          // 各カードの実描画位置（先頭カード基準）
  var carSnaps = [0];           // 到達可能なスナップ位置
  var carMaxScroll = 0;
  var carRequestedIndex = null; // ボタンで要求した移動先
  var carProgrammatic = false;  // ボタン操作による移動中
  var carSettleTimer = null;

  /* 実描画位置から幾何情報を測り直す。★推定値を使わない */
  function carMeasure() {
    if (!carTrack || !carItems.length) return;
    var base = carItems[0].offsetLeft;
    carOffsets = [];
    for (var i = 0; i < carItems.length; i++) {
      carOffsets.push(carItems[i].offsetLeft - base);
    }
    carMaxScroll = Math.max(0, carTrack.scrollWidth - carTrack.clientWidth);
    carSnaps = M.buildSnaps(carOffsets, carMaxScroll, M.EPS_SNAP);
  }

  /* ★位置判定の正本。実 scrollLeft から現在位置を導出する */
  function carActualIndex() {
    return M.nearestIndex(carSnaps, carTrack.scrollLeft);
  }

  /* 表示を実 scrollLeft へ同期する。内部の番号を根拠にしない */
  function carRender() {
    if (!carTrack) return;
    var left = carTrack.scrollLeft;
    var total = carItems.length;
    var st = M.disabledState(left, carMaxScroll, M.EPS_EDGE);
    var cv = M.counterValue(left, carMaxScroll, carOffsets, total, M.EPS_EDGE);

    if (carPos) {
      carPos.textContent = st.allVisible
        ? ('All ' + total + ' shown')
        : (cv.value + ' / ' + total);
      carPos.setAttribute('data-all-visible', st.allVisible ? 'true' : 'false');
    }
    if (carHint) {
      carHint.setAttribute('data-all-visible', st.allVisible ? 'true' : 'false');
    }
    if (carPrev) {
      carPrev.disabled = st.prev;
      carPrev.setAttribute('aria-disabled', String(st.prev));
      carPrev.title = st.allVisible ? 'All brands are shown' : 'Previous brands';
    }
    if (carNext) {
      carNext.disabled = st.next;
      carNext.setAttribute('aria-disabled', String(st.next));
      carNext.title = st.allVisible ? 'All brands are shown' : 'Next brands';
    }
  }

  /* プログラム移動の保留状態を解除し、実位置へ戻す */
  function carClearPending() {
    carProgrammatic = false;
    carRequestedIndex = null;
    if (carSettleTimer) { window.clearTimeout(carSettleTimer); carSettleTimer = null; }
  }

  /* 移動の完了を検出する。
     scrollend が使えない環境では短い debounce で代用する */
  var carHasScrollEnd = (typeof window !== 'undefined') && ('onscrollend' in window);

  function carArmSettle() {
    if (carHasScrollEnd) return;            // scrollend が処理する
    if (carSettleTimer) window.clearTimeout(carSettleTimer);
    carSettleTimer = window.setTimeout(function () {
      carSettleTimer = null;
      carClearPending();
      carRender();
    }, 120);
  }

  /* 矢印。★現在の実 scrollLeft を基準にする。
     ただしプログラム移動中の連続クリックは、
     すでに要求済みの位置を基準にして取りこぼさない。 */
  function carArrow(delta) {
    if (!carTrack) return;
    carMeasure();                            // クリックのたびに測り直す
    var base = (carProgrammatic && carRequestedIndex !== null)
      ? carRequestedIndex
      : carActualIndex();
    carRequestedIndex = M.stepIndex(base, delta, carSnaps.length);
    carProgrammatic = true;

    var target = carSnaps[carRequestedIndex];
    /* ★滑らかさより位置の正確性を優先する。
       CSS の scroll-behavior は auto にしてあるため 'auto' は即時移動になる。
       reduced motion でも同じ経路を通る（必ず即時）。 */
    if (typeof carTrack.scrollTo === 'function') {
      try { carTrack.scrollTo({ left: target, behavior: 'auto' }); }
      catch (e) { carTrack.scrollLeft = target; }
    } else {
      carTrack.scrollLeft = target;
    }
    carRender();                             // 移動後の実位置で描画する
    carArmSettle();
  }

  /* 手動操作。プログラム移動の保留を解除し、実位置を正本に戻す */
  function carOnManual() {
    carClearPending();
    carRender();
  }

  function carRecalc() {
    if (!carTrack) return;
    carMeasure();
    carClearPending();
    carRender();
  }

  function setupCarousel() {
    carTrack = document.querySelector('[data-carousel]');
    if (!carTrack) return;
    carPrev = document.querySelector('[data-carousel-prev]');
    carNext = document.querySelector('[data-carousel-next]');
    carPos = document.querySelector('[data-carousel-pos]');
    carHint = document.querySelector('[data-carousel-hint]');

    carItems = [];
    for (var i = 0; i < carTrack.children.length; i++) {
      carItems.push(carTrack.children[i]);
    }
    if (!carItems.length) return;

    if (carPrev) {
      carPrev.addEventListener('click', function () { carArrow(-1); });
    }
    if (carNext) {
      carNext.addEventListener('click', function () { carArrow(1); });
    }

    /* 手動操作の検出。★これらは常にプログラム移動より優先する */
    var manualEvents = ['pointerdown', 'touchstart', 'wheel'];
    for (var e = 0; e < manualEvents.length; e++) {
      carTrack.addEventListener(manualEvents[e], carOnManual, { passive: true });
    }
    carTrack.addEventListener('keydown', function (ev) {
      var k = ev.key;
      if (k === 'ArrowLeft' || k === 'ArrowRight' ||
          k === 'Home' || k === 'End' ||
          k === 'PageUp' || k === 'PageDown') {
        carOnManual();
      }
    });

    /* ネイティブスクロール中も表示を実位置へ追従させる */
    carTrack.addEventListener('scroll', function () {
      carRender();
      if (!carProgrammatic) { carArmSettle(); }
    }, { passive: true });

    if (carHasScrollEnd) {
      carTrack.addEventListener('scrollend', function () {
        carClearPending();
        carRender();
      });
    }

    carMeasure();
    carRender();

    /* ★書体・枠の寸法が確定した後に測り直す（初回クリック無反応の防止） */
    if (document.readyState !== 'complete') {
      window.addEventListener('load', carRecalc, { once: true });
    }
  }


  /* ------------------------------------------------------------------
     5. reduced-motion の変更に追随する
     ------------------------------------------------------------------ */
  function applyMotionMode() {
    if (reduceMQ.matches) {
      stopObserving();
      showAll();
      heroStop();
    } else {
      startObserving();
    }
    setupHero();
  }

  function onChange() { applyMotionMode(); }

  if (typeof reduceMQ.addEventListener === 'function') {
    reduceMQ.addEventListener('change', onChange);
  } else if (typeof reduceMQ.addListener === 'function') {
    reduceMQ.addListener(onChange);
  }

  /* ------------------------------------------------------------------
     6. 画面幅の変更（デバウンス 150ms）
     ------------------------------------------------------------------ */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      measureLines();
      setupHero();
      carRecalc();          // ★位置と番号を測り直す
    }, 150);
  });

  /* ------------------------------------------------------------------
     7. 起動
     ------------------------------------------------------------------ */
  function init() {
    measureLines();
    applyMotionMode();
    setupCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})(); }
